import jwtDecode from 'jwt-decode';

export const isLogin = (): boolean => {
  const authToken = localStorage.getItem('charisma-token');
  if (!authToken || authToken === '') return false;

  // A 2FA setup token is not a valid session
  try {
    const decoded: any = jwtDecode(authToken);
    if (decoded.action === '2fa_setup') return false;
  } catch {
    return false;
  }

  return true;
};

export const saveToken = (token: string): void => {
  localStorage.setItem('charisma-token', token);
};

export const deleteToken = (): void => {
  localStorage.removeItem('charisma-token');
};

export const logout = (): void => {
  deleteToken();
  window.location.replace('/login');
};

export const tokenAction = (token: string) => {
  const decoded: any = jwtDecode(token);
  return decoded.action;
};
